<template>
  <admin-wrapper
    title-translation-path="admin.dataDatasources"
    subtitle-path="admin.dataDatasourcesSubtitle"
    :hasButtons="false"
    :is-fetched="isFetched"
  >
    <template #form>
      <v-row no-gutters>
        <v-col :lg="12" :xl="11">
          <data-sources-settings-list
            :data-sources="computedDataSources"
            :is-fetched="isFetched"
            has-add-button
          ></data-sources-settings-list>
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import DataSourcesSettingsList from '@/components/DataSourcesSettingsList';

import { get, call } from 'vuex-pathify';

export default {
  name: 'AdminDataDatasources',
  components: {
    AdminWrapper,
    DataSourcesSettingsList,
  },
  data: () => ({
    isFetched: false,
  }),
  computed: {
    dataSources: get('layers/metadata'),
    computedDataSources() {
      return Object.values(this.dataSources).filter(value => value.scope === 'core');
    },
  },
  methods: {
    getDatasourcesSettings: call('datasourceSettings/getDatasourcesSettings'),
    getDataSources: call('layers/getLayersMetadata'),
    async onInit() {
      await Promise.all([
        this.getDatasourcesSettings(),
        this.getDataSources({
          with_attributes_schema: true,
          scope: 'core',
          with_layers: true,
          with_last_edit: true,
          with_owner: true,
        }),
      ]);
      this.isFetched = true;
    },
  },
  created() {
    this.onInit();
  },
};
</script>
